import UserListOrganism from '../../organisms/UserList/UserListOrganism';

interface UsersMoleculeProps {
  organizationId: string;
}

/**
 * @deprecated Use UserListOrganism directly instead.
 */
export default function UsersMolecule({ organizationId }: UsersMoleculeProps) {
  return <UserListOrganism organizationId={organizationId} />;
}
